/* eslint-disable */

import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import defineAbilitiesFor from "@/config/ability";
import Layout from "@/components/Layout/Layout";
import { getRouteGuardToastMessage } from "@/utils/permissions";
import { installStaleBundleHandlers } from "@/services/versionCheck";
import { addDemoRoutes } from '@/pages/Demo/demoRoutes';

// MyAccount
import MyAccount from '@/pages/MyAccount/MyAccount';
import A2PRegistrationPage from '@/pages/MyAccount/A2P/index.vue';

// Home
import HomePage from "@/pages/Home/Home";
import AdminPage from "@/pages/Admin/AdminPage";
import AdminPage2 from "@/pages/Admin/AdminPage2";
import AdminByEmployeePage from "@/pages/Admin/AdminByEmployeePage";
import WikiHome from "@/pages/WikiHome/WikiHome";
import WikiCreate from "@/pages/WikiCreate/WikiCreate";
import WikiView from "@/pages/WikiView/WikiView";
import WikiEdit from "@/pages/WikiView/WikiEdit";
import PublicWikiView from "@/pages/WikiView/PublicWikiView";
import Task from "@/pages/Home/components/Task/Task";
import Login from "@/pages/Login/Login";
import OverdueRecall from '@/pages/OverdueRecall/OverdueRecall'
import OverdueRecallList from '@/pages/OverdueRecall/OverdueRecallList'
// The route renders PatientProfileRoute: the classic PatientProfile.vue, or the new page — Super Admins by
// default, office users per STAGE.patientProfileLayout and their choice (docs/plans/2026-10-08-patient-profile-overhaul-plan.md).
import PatientProfileRoute from '@/pages/PatientProfile/PatientProfileRoute'
import UnscheduledList from '@/pages/UnscheduledList/UnscheduledList'
import UnscheduledTreatment from '@/pages/UnscheduledTreatment/UnscheduledTreatment'
import TxPresenterDashboard from '@/pages/TxPresenter/TxPresenterDashboard'
import TxPresenterBuilder from '@/pages/TxPresenter/TxPresenterBuilder'
import TxPresenterPresentMode from '@/pages/TxPresenter/TxPresenterPresentMode'
import TxPresenterSettings from '@/pages/TxPresenter/TxPresenterSettings'
import InsuranceVerification from '@/pages/InsuranceVerification/InsuranceVerification'
import TxPatientView from '@/pages/TxPatientView/TxPatientView'
import ReviewLanding from '@/pages/ReviewLanding/ReviewLanding'

import TeamInsights from '@/pages/TeamInsights/TeamInsights';
import Aging from '@/pages/Aging/Aging';
import BrokenAppointments from '@/pages/BrokenAppointments/BrokenAppointments';
import Settings from '@/pages/Settings/Settings';
import AsapList from '@/pages/AsapList/AsapList';

import Checklists from '@/pages/Checklists/Checklists';
import CreateChecklist from '@/pages/Checklists/CreateChecklist';
import ViewChecklist from '@/pages/Checklists/ViewChecklist';

import Routine from "@/pages/Routine/Routine";
import CreateRoutine from "@/pages/Routine/CreateRoutine";
import ViewRoutine from "@/pages/Routine/ViewRoutine";

import WhatsNew from '@/pages/WhatsNew/WhatsNew';
import Reports from '@/pages/Reports/Reports';
import TeamInsightsCustomReports from '@/pages/TeamInsightsCustomReports/TeamInsightsCustomReports';

import ToDo from '@/pages/TaskList/ToDo'
import ShapeShiftDemo from '@/pages/TaskList/ShapeShiftDemo'
import SuperAdmin from '@/pages/Gautam/SuperAdmin';
import ScheduleView from '@/pages/ScheduleView/ScheduleView.vue';
import KPI from '@/pages/KPI/KPI';
//import KPITemplate from '@/pages/KPI-Template/KPI';

//import FLOT from '@/pages/Charts/Flot/Flot.vue';
import Chat from '@/pages/Chat/Chat.vue';


import Huddle from '@/pages/Huddle/Huddle.vue';

import Workflow from '@/pages/Workflow/Workflow';
import CreateWorkflow from '@/pages/Workflow/CreateWorkflow';
import WorkflowOutput from '@/pages/Workflow/WorkflowOutput';
import Conversations from '@/pages/Conversations/Conversations';
import AptReminder from '@/pages/AptReminder/AptReminder';
import Reviews from '@/pages/Reviews/Reviews';

// Forms related
import FormsHome from '@/pages/Forms/components/FormsHome';
import Start from "@/pages/Forms/components/Start";
import CreateForm from "@/pages/Forms/components/CreateForm";
import EditForm from "@/pages/Forms/components/EditForm";
import ViewForm from "@/pages/Forms/components/ViewForm";
import VerifyForm from "@/pages/Forms/components/VerifyForm";
import IdentifyPatient from "@/pages/Forms/components/IdentifyPatient";
import ViewSubmission from "@/pages/Forms/components/ViewSubmission";
import ViewSubmissionForPDF from "@/pages/Forms/components/ViewSubmissionForPDF";
import FormResult from "@/pages/Forms/components/FormResult";

// The route renders PracticeOpsRoute: the classic PracticePulse.vue, or the redesigned Practice Ops page — Super Admins by
// default, office users per STAGE.practiceOps and their choice (docs/plans/2026-10-30-practice-ops-plan.md). Path, name and permission stay practice-pulse.
import PracticeOpsRoute from '@/pages/PracticePulse/PracticeOpsRoute';

// Online Appointments
import OnlineAppointments from '@/pages/OnlineAppointments/OnlineAppointments';

// Campaigns
import Campaigns from '@/pages/Campaigns/Campaigns';
import CampaignDetail from '@/pages/Campaigns/CampaignDetail';
import CampaignDrafts from '@/pages/Campaigns/Drafts';
import CampaignStatistics from '@/pages/Campaigns/Statistics';
import CampaignTemplates from '@/pages/Campaigns/Templates';
import CampaignABTests from '@/pages/Campaigns/ABTests';

import UrlRedirect from '@/pages/UrlRedirect/UrlRedirect';
import BookingRedirect from '@/pages/BookingRedirect/BookingRedirect';
import CampaignTrackRedirect from '@/pages/CampaignTrackRedirect/CampaignTrackRedirect';
import ProcessPayment from '@/pages/Moolah/ProcessPayment';
import PaymentSuccess from '@/pages/Payments/PaymentSuccess';

// WhatsApp Tech Provider — public customer-facing Embedded Signup page
import WhatsAppConnect from '@/pages/WhatsAppConnect/WhatsAppConnect';

import Kanban from '@/pages/Kanban/Kanban';

import Test from '@/pages/Test/Test';
import VideoTest from '@/pages/VideoTest/VideoTest';
import TaskManager from '@/pages/Task2/TaskManager';

// Workflow2 - New modern workflow builder
import Workflow2List from '@/pages/Workflow2/WorkflowListRoute';
import Workflow2Builder from '@/pages/Workflow2/WorkflowBuilderRoute';
import Workflow2Output from '@/pages/Workflow2/WorkflowOutput';
// Keep old Workflow2 for backwards compatibility (will be removed later)
import Workflow2 from '@/pages/Workflow2/Workflow';
import SelectSite from "@/pages/Login/SelectSite";

import AppointmentCalendar from '@/pages/Calendar/AppointmentCalendar';

// Bot Admin Interface
import AdminLayout from '@/pages/Calendar/admin/AdminLayout';
import Dashboard from '@/pages/Calendar/admin/Dashboard';
import ConversationList from '@/pages/Calendar/admin/BotConversations/ConversationList';
import ConversationDetail from '@/pages/Calendar/admin/BotConversations/ConversationDetail';
import AppointmentStats from '@/pages/Calendar/admin/AppointmentStats.vue';

// Calendar Admin Interface components (ensure all are imported)
import CalendarAdminDashboard from '@/pages/Calendar/admin/Dashboard'; // Alias for clarity
import CalendarAdminBotConversationList from '@/pages/Calendar/admin/BotConversations/ConversationList'; // Alias
import CalendarAdminBotConversationDetail from '@/pages/Calendar/admin/BotConversations/ConversationDetail'; // Alias
import CalendarAdminAppointmentStats from '@/pages/Calendar/admin/AppointmentStats.vue'; // Alias
import CalendarAdminKnowledge from '@/pages/Calendar/admin/Knowledge/KnowledgeBase.vue'; // Receptionist Knowledge tab (E1+E2)

/* https://stackoverflow.com/questions/51980296/detect-back-button-in-navigation-guards-of-vue-router */
/*
window.popStateDetected = false
window.addEventListener('popstate', () => {
  window.popStateDetected = true
})
*/

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    /*
    {
      path: "/",
      redirect: localStorage.getItem('redirectPath') || '/login'
    },
    */
    {
      path: "/process-payment/:paymentID",
      name: "ProcessPayment",
      component: ProcessPayment,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      // WhatsApp Tech Provider — public Embedded Signup page the customer opens
      // from the operator-sent link (…/whatsapp-connect?token=…). No admin auth.
      path: "/whatsapp-connect",
      name: "WhatsAppConnect",
      component: WhatsAppConnect,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      // Slice 7 — patient-facing treatment plan view (no admin auth; shortId is the only token)
      path: "/tx/:shortId",
      name: "TxPatientView",
      component: TxPatientView,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      // Reviews A4 — public patient rating page (no admin auth; shortId is the only token)
      path: "/rv/:shortId",
      name: "ReviewLanding",
      component: ReviewLanding,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/payment-success/:paymentId",
      name: "PaymentSuccess",
      component: PaymentSuccess,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/l/:urlID",
      name: "UrlRedirect",
      component: UrlRedirect,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/b/:urlID",
      name: "BookingRedirect",
      component: BookingRedirect,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/ct/:linkID",
      name: "CampaignTrackRedirect",
      component: CampaignTrackRedirect,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/verify-form/:formUrlID",
      name: "VerifyForm",
      component: VerifyForm,
      props: true,      
      meta: {
        requiresAuth: false
      }      
    },
    {
      // "Existing patients" generic form/packet link: DOB + name, then a one-time code, then on to
      // /l/<patient-specific urlID>. Public. Deliberately NOT in the verify-form "from.name === null →
      // /login" guard below: a refresh here is legitimate (the page re-resolves siteID from the urlID).
      path: "/identify-patient/:urlID",
      name: "IdentifyPatient",
      component: IdentifyPatient,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/view-form/:formUrlID/:urlID?",
      name: "ViewFormWithUrlID",
      component: ViewForm,
      props: true,
      meta: {
        requiresAuth: false,
        requiresFormVerification: true
      }
    },
    {
      path: "/preview-form/:previewFormID",
      name: "PreviewForm",
      component: ViewForm,
      props: true,
      meta: {
        requiresAuth: true,  // Only authenticated users can preview
        isPreviewMode: true
      }
    },
    {
      path: "/view-form-result",
      name: "FormResult",
      props: true,
      component: FormResult,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/view-wiki/:wikiPageID",
      name: "PublicWikiView",
      component: PublicWikiView,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/view-submission-for-pdf/:formSubmissionID",
      name: "ViewSubmissionForPDF",
      props: true,
      component: ViewSubmissionForPDF,
      meta: {
        requiresAuth: false
      }
    },    
    {
      path: "/appointment-calendar",
      name: "AppointmentCalendar",
      component: AppointmentCalendar,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: "/calendar/admin",
      component: AdminLayout,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "CalendarAdminDashboardRedirect",
          redirect: "dashboard"
        },
        {
          path: "dashboard",
          name: "CalendarAdminDashboard",
          component: CalendarAdminDashboard,
          meta: { requiresAuth: true }
        },
        {
          path: "bot-conversations",
          name: "CalendarAdminBotConversationList",
          component: CalendarAdminBotConversationList,
          // Admin-capable (site Admins + Super Admins), not super-admin-only.
          // meta.requires drives the CASL route guard in router.beforeEach.
          meta: { requiresAuth: true, requires: { action: 'read', subject: 'ai-call-history' } }
        },
        {
          path: "bot-conversations/:id",
          name: "CalendarAdminBotConversationDetail",
          component: CalendarAdminBotConversationDetail,
          props: true,
          meta: { requiresAuth: true, requires: { action: 'read', subject: 'ai-call-history' } }
        },
        {
          path: "appointment-stats",
          name: "CalendarAdminAppointmentStats",
          component: CalendarAdminAppointmentStats,
          meta: { requiresAuth: true }
        },
        {
          // Receptionist Knowledge Base — review/approve tab (E1+E2). Gated by the
          // same CASL subject as the call-history page (admin-capable). The bot
          // also double-gates server-side (AI_KB_ENABLED + assertSiteAdmin); a 403
          // renders a friendly "not enabled" state.
          path: "knowledge",
          name: "CalendarAdminKnowledge",
          component: CalendarAdminKnowledge,
          meta: { requiresAuth: true, requires: { action: 'read', subject: 'ai-call-history' } }
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    
    {
      path: "/select-site",
      name: "SelectSite",
      component: SelectSite,
      props: true,
      meta: {
        requiresAuth: false
      }
    },
    
    {
      path: "/app",
      //name: 'Layout',
      component: Layout,
      children: [

        {
          path: "task2",
          name: "TaskManager",
          component: TaskManager,          
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "test",
          name: "Test",
          component: Test,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "video-test",
          name: "VideoTest",
          component: VideoTest,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "kanban",
          name: "Kanban",
          component: Kanban,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'kanban' }
          }
        },

        {
          path: "practice-pulse",
          name: "PracticePulse",
          component: PracticeOpsRoute,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'practice-pulse' }
          }
        },
        {
          path: "/",
          redirect: localStorage.getItem('redirectPath') || '/login'
        },
        {
          path: "my-account",
          name: "MyAccount",
          component: MyAccount,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'myaccount' }
          }
        },
        {
          path: "my-account/a2p",
          name: "A2PRegistration",
          component: A2PRegistrationPage,
          meta: { requiresAuth: true, requires: { action: 'view', subject: 'myaccount' } }
        },
        { 
          path: "forms",
          name: "Forms",
          component: FormsHome,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'forms' }
          }
        },
        {
          path: "forms/create-form",
          name: "CreateForm",
          component: CreateForm,
          meta: {
            requiresAuth: true,
            requires: { action: 'edit', subject: 'forms' }
          }
        },
        {
          path: "forms/edit-form/:formID",
          name: "EditForm",
          component: EditForm,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'edit', subject: 'forms' }
          }
        },

        {
          path: "forms/view-submission/:formSubmissionID",
          name: "ViewSubmission",
          props: true,
          component: ViewSubmission,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'forms' }
          }
        },

        {
          path: "kpi",
          name: "kpi",
          component: KPI,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'kpi' }
          }
        },
        {
          path: "chat",
          name: "chat",
          component: Chat,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'chat' }
          }
        },

        {
          path: "conversations",
          name: "conversations",
          component: Conversations,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'conversations' }
          }
        },
        /*
        {
          path: "kpi-template",
          name: "kpi-template",
          component: KPITemplate,
          meta: {
            requiresAuth: true
          }
        },
        */
        
        {
          path: "Gautam/SuperAdmin",
          name: "super-admin",
          component: SuperAdmin,
          meta: {
            requiresAuth: true,
            requiresSuperAdmin: true
          }
        },

        // Schedule - Chart Audit (Schedule View) — the day's operatory schedule + a chart audit on
        // every appointment.
        // Open to every office that qualifies, through the CASL subject 'schedule' (config/ability.js,
        // rule in utils/scheduleView/access.js): the office's SCHEDULE_VIEW_ENABLED switch is on AND its
        // Teamio app is 3.0.61+, and the role is not Outsourced. Anyone else typing /app/schedule is
        // bounced to /app by the meta.requires guard in router.beforeEach, and Sidebar.vue / the new
        // shell draw no entry for them. Super Admins always have it (a banner says when the office
        // does not qualify). The service refuses the data below the minimum regardless.
        // Plan: docs/plans/2026-10-28-schedule-chart-audit-release-plan.md
        {
          path: "schedule",
          name: "schedule-view",
          component: ScheduleView,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'schedule' }
          }
        },
        {
          path: "todo",
          name: "ToDo",
          component: ToDo,
          meta: { 
            requiresAuth: true
          },
        },
        { path: "tasks-shapeshift", name: "TasksShapeShift", component: ShapeShiftDemo, meta: { requiresAuth: true } },
        {
          path: "todo/:taskID",
          name: "ToDoID",
          props: true,
          component: ToDo,
          meta: { 
            requiresAuth: true
          },
        },
        {
          path: "reports",
          name: "reports",
          component: Reports,
          meta: { 
            requiresAuth: true
          },
        },
        // Campaigns routes
        {
          path: "campaigns",
          name: "campaigns",
          component: Campaigns,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'campaigns' }
          },
        },
        {
          path: "campaigns/:campaignId",
          name: "campaignDetail",
          component: CampaignDetail,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'campaigns' }
          },
        },
        {
          path: "campaigns-drafts",
          name: "campaignDrafts",
          component: CampaignDrafts,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'campaigns' }
          },
        },
        {
          path: "campaigns-statistics",
          name: "campaignStatistics",
          component: CampaignStatistics,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'campaigns' }
          },
        },
        {
          path: "campaigns-templates",
          name: "campaignTemplates",
          component: CampaignTemplates,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'campaigns' }
          },
        },
        {
          path: "campaigns-ab-tests",
          name: "campaignABTests",
          component: CampaignABTests,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'campaigns' }
          },
        },
        {
          path: "team-insights-custom-reports",
          name: "TeamInsightsCustomReports",
          component: TeamInsightsCustomReports,
          meta: { 
            requiresAuth: true
          },
        },
        {
          path: "whatsnew",
          name: "whatsnew",
          component: WhatsNew
        },
        // main pages

        {
          path: "checklists",
          name: "Checklists",
          component: Checklists,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "create-checklist",
          name: "CreateChecklist",
          component: CreateChecklist,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "view-checklist/:checklistID",
          name: "ViewChecklist",
          component: ViewChecklist,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "routine",
          name: "Routine",
          component: Routine
        },
        {
          path: "createroutine",
          name: "createroutine",
          component: CreateRoutine,
          meta: {
            requiresAuth: true
          }
        },

        {
          path: "viewroutine/:routineID",
          name: "ViewRoutine",
          component: ViewRoutine,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
          
        {
          path: 'broken-appointments',
          name: 'BrokenAppointments',
          component: BrokenAppointments,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'broken_appointment' }
          },
        },
        {
          path: 'asap-list',
          name: 'AsapList',
          component: AsapList,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'asap_list' }
          },
        },
        {
          path: 'overdue-recall',
          name: 'OverdueRecall',
          component: OverdueRecall,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'overdue_recall' }
          },
        },
        {
          path: 'overdue-recall-list/:listID',
          name: 'OverdueRecallList',
          component: OverdueRecallList,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'overdue_recall' }
          },
        },

        {
          path:'aging',
          name: 'Aging',
          component: Aging,
          meta: {
            requiresAuth: true,
            // Aging bundles three follow-up types into one page (Outstanding
            // Claims, Outstanding PreAuths, Patient Balances). The route is
            // accessible if the user can view ANY of the three — per-tab
            // restricted state inside Aging.vue handles the rest. Before
            // 2026-05-26 this declared a single { subject: 'patient_balances' }
            // which silently locked out users who had outstanding_claim access
            // only (including the Phase-9 customer.js post-login redirect path
            // that could otherwise produce an infinite redirect loop).
            requires: [
              { action: 'view', subject: 'outstanding_claim' },
              { action: 'view', subject: 'outstanding_preauths' },
              { action: 'view', subject: 'patient_balances' },
            ]
          },
        },

        {
          path: "admin",
          name: "AdminPage",
          component: AdminPage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "admin2",
          name: "AdminPage2",
          component: AdminPage2,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "admin-by-employee",
          name: "AdminByEmployeePage",
          component: AdminByEmployeePage,
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "wiki",
          name: "WikiHome",
          component: WikiHome,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'wiki' }
          }
        },
        {
          path: "wiki/:tags",
          name: "WikiHomeTags",
          component: WikiHome,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'wiki' }
          }
        },
        {
          path: "wikicreate",
          name: "WikiCreate",
          component: WikiCreate,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'wiki' }
          }
        },
        {
          path: "wikiview/:wikiPageID",
          name: "WikiView",
          component: WikiView,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'wiki' }
          }
        },
        {
          path: "wikiedit/:wikiPageID",
          name: "WikiEdit",
          component: WikiEdit,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'wiki' }
          }
        },
        // Workflow2 - New modern workflow builder routes
        {
          path: "workflow2",
          name: "Workflow2",
          component: Workflow2, // Old canvas-based builder (for backwards compatibility)
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow2-list",
          name: "Workflow2List",
          component: Workflow2List,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow2-create",
          name: "CreateWorkflow2",
          component: Workflow2Builder,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow2-edit/:workflowID",
          name: "ViewWorkflow2",
          component: Workflow2Builder,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow2-output/:workflowID",
          name: "WorkflowOutput2",
          component: Workflow2Output,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow",
          name: "Workflow",
          component: Workflow,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow/:workflowID",
          name: "ViewWorkflow",
          component: CreateWorkflow,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "create-workflow",
          name: "CreateWorkflow",
          component: CreateWorkflow,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
        {
          path: "workflow-output/:workflowID",
          name: "WorkflowOutput",
          component: WorkflowOutput,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'workflow' }
          }
        },
      
        {
          path: "patientprofile/:patientID",
          name: "patientprofile",
          component: PatientProfileRoute,
          props: true,
          meta: {
            requiresAuth: true
          }
        },
        {
          path:'unscheduled-list/:listID',
          name: 'unscheduledList',
          component: UnscheduledList,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'unscheduled_treatment' }
          }
        },
        {
          path:'unscheduled-treatment',
          name: 'unscheduledTreatment',
          component: UnscheduledTreatment,
          props: true,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'unscheduled_treatment' }
          }
        },
        {
          // Tx Presenter access is now per-site. Toggle TX_PRESENTER_ENABLED
          // in Gautam → SuperAdmin → Features for a practice to open the
          // sidebar entry + all Tx Presenter routes for that site's users.
          // Super Admin always has access regardless of the flag.
          path: 'tx-presenter',
          name: 'TxPresenter',
          component: TxPresenterDashboard,
          meta: {
            requiresAuth: true,
            requiresTxPresenter: true
          }
        },
        {
          path: 'tx-presenter/builder/:patNum/:treatPlanNum',
          name: 'TxPresenterBuilder',
          component: TxPresenterBuilder,
          props: true,
          meta: {
            requiresAuth: true,
            requiresTxPresenter: true
          }
        },
        {
          // Slice 9a — Present Mode. Full-screen chairside walkthrough that
          // reuses the same 3 view components as Builder. Entry from the
          // Builder top bar "Present in-office" button; exit returns here.
          path: 'tx-presenter/present/:patNum/:treatPlanNum',
          name: 'TxPresenterPresentMode',
          component: TxPresenterPresentMode,
          props: true,
          meta: {
            requiresAuth: true,
            requiresTxPresenter: true
          }
        },
        {
          path: 'tx-presenter/settings',
          name: 'TxPresenterSettings',
          component: TxPresenterSettings,
          meta: {
            requiresAuth: true,
            requiresTxPresenter: true
          }
        },
        {
          // Insurance Verification ("Benefits & eligibility") dashboard.
          // Per-site: toggle INSURANCE_VERIFICATION_ENABLED in Gautam →
          // SuperAdmin → Features to open the sidebar entry + route for a
          // practice's users. Super Admin always has access (safety net).
          //
          // TWO gates, deliberately ANDed — they answer different questions:
          //   requiresInsuranceVerification → is this SITE turned on? (flag OR Super Admin)
          //   requires                      → may this PERSON spend? (CASL, per-role,
          //                                   overridable via FEATURE_PERMISSIONS)
          // The second exists because every action on this page is a billed Stedi check.
          // The generic meta.requires guard runs first in beforeEach and is tolerant of an
          // unhydrated store (it only enforces once settings have loaded), so a cold-boot
          // deep link degrades the same way the flag gate already does.
          path: 'insurance-verification',
          name: 'InsuranceVerification',
          component: InsuranceVerification,
          meta: {
            requiresAuth: true,
            requiresInsuranceVerification: true,
            requires: { action: 'view', subject: 'insurance-verification' }
          }
        },
        {
          path:'team-insights',
          name: 'teamInsights',
          component: TeamInsights,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'team-insights' }
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          component: Settings,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'settings' }
          }
        },
        {
          path: 'huddle',
          name: 'Huddle',
          component: Huddle,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'huddle' }
          }
        },
        {
          path: 'apt-reminder',
          name: 'AptReminder',
          component: AptReminder,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'apt-reminder' }
          }
        },
        {
          path: 'reviews',
          name: 'Reviews',
          component: Reviews,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'reviews' }
          }
        },
        {
          path: 'online-appointments',
          name: 'OnlineAppointments',
          component: OnlineAppointments,
          meta: {
            requiresAuth: true,
            requires: { action: 'view', subject: 'online-appointments' }
          }
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  //console.log('to, from, next', to, from, next);
  //console.dir(from);
  //console.dir(to);
  //console.dir(next);

  // Action Center preview-mode sticky query param.
  //
  // Super Admins can append `?actionCenterPreview=1` to any URL to see what
  // non-admins see in the AgentSidebar. Without propagation, the first
  // in-app link click (router-link / $router.push) navigates to a URL
  // without the param and the preview dies immediately — Saumil hit this
  // when clicking "View Form" on a bot event 2026-05-20.
  //
  // Fix: if FROM had `actionCenterPreview=1` and TO doesn't carry any
  // value for that key, redirect to TO with the param added. To exit
  // preview mode, explicitly navigate to a URL with no param OR with
  // a different value (e.g. `?actionCenterPreview=0`) — we only sticky
  // when TO has no opinion at all.
  if (from && from.query && from.query.actionCenterPreview === '1') {
    const toHasParam = to.query && Object.prototype.hasOwnProperty.call(to.query, 'actionCenterPreview');
    if (!toHasParam) {
      return next({
        path: to.path,
        query: { ...to.query, actionCenterPreview: '1' },
        hash: to.hash,
        replace: true,
      });
    }
  }

  // prevent them from clicking back on FormResult page

  if(to.name === 'ViewSubmission' && from.name === 'FormResult') {
    alert('Please do not click back after form submission. You can close this window and go back to main site');
    return false;
  }

  if(to.path.indexOf('[PatNum]') !== -1) {
    //console.log('going to patient profile without proper patnum..lets redirect to app');
    return next('/app');
  }

  if(to.path !== "/app/conversations")
    window.scrollTo(0, 0);

  // if somehow someone got to the verify-form directly then it's going to be missing siteid, just redirect them to login
  if(to.path.indexOf('/verify-form/') !== -1) {    
    if(from.name === null)
      return next('/login');
  }
  /*
  const isItABackButton = window.popStateDetected
  window.popStateDetected = false
  console.log('back button:' + isItABackButton);
  console.dir(to);
  console.dir(from);
  */  

  // redirect to login page if not logged in and trying to access a restricted page
  //const publicPages = ['/login', '/register'];
  //const authRequired = !publicPages.includes(to.path) && !to.path.startsWith("/view-form");

  const authRequired = to.meta.requiresAuth;
  const loggedIn = localStorage.getItem('authenticated');
  const formVerified = localStorage.getItem('formverified');

  //console.log(`formVerified: ${formVerified}`);

  // CASL-driven route guard: when a route declares `meta.requires`, check
  // `ability.can(action, subject)` for the current user using the same
  // defineAbilitiesFor pipeline that powers every `v-if="$can(...)"` in
  // the app. This honors FEATURE_PERMISSIONS overrides (set via MyAccount)
  // AND per-employee responsible-list rules in ability.js (e.g. an
  // Employee whose ID is in OVERDUE_RECALL_RESPONSIBLE_EMPLOYEEID keeps
  // access to /app/overdue-recall even though Employees broadly don't).
  //
  // Cold-boot trade-off: on a deep-link refresh, customer settings may
  // not be hydrated in the store yet, which would make the responsible-
  // list rules silently fail. Rather than risk locking out a legitimate
  // user mid-workflow, we let the navigation through when settings are
  // empty — sidebar v-ifs catch up once the store loads. Same pattern
  // as requiresTxPresenter below.
  if (loggedIn && to.meta.requires) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        const settingsArray = (store && store.state && store.state.customer && store.state.customer.settings) || [];
        if (settingsArray.length > 0) {
          const settings = {};
          settingsArray.forEach(s => { if (s && s.Property) settings[s.Property] = s; });
          // `sites` feeds Schedule - Chart Audit's owner-exe-version rule (config/ability.js).
          const ability = defineAbilitiesFor(user, settings, { sites: store.state.customer.sites });
          // meta.requires accepts either a single { action, subject } object
          // OR an array of such pairs. Array form is OR semantics: pass if
          // ANY pair is satisfied. This lets a multi-tab page like Aging
          // (Outstanding Claims + Outstanding PreAuths + Patient Balances)
          // declare "any one of these is enough" — without the array form
          // the route guard incorrectly blocked users who had access to one
          // of the tabs but not all three.
          const reqs = Array.isArray(to.meta.requires) ? to.meta.requires : [to.meta.requires];
          if (reqs.length > 0 && !reqs.some(r => ability.can(r.action, r.subject))) {
            // Surface a toast naming the relevant *_RESPONSIBLE_EMPLOYEEID
            // setting so the user knows what to ask their admin. Without
            // this, the redirect is silent and confusing — users follow a
            // stale link or URL-type and just get bounced to /app with no
            // explanation. For the array form we use the first listed
            // subject to drive the page label in the toast (the rest are
            // alternatives; the user only needs one). Toast copy is
            // centralized in utils/permissions.
            try {
              const msg = getRouteGuardToastMessage(reqs[0].subject);
              store.dispatch('alert/setMessage', msg, { root: true });
              store.dispatch('alert/setErrored', true, { root: true });
            } catch (toastErr) {
              // Never let the toast dispatch break the redirect.
              console.warn('Route guard toast dispatch failed:', toastErr);
            }
            return next('/app');
          }
        }
      }
    } catch (e) {
      // Never break navigation on a guard parse error — fall through.
      console.warn('Route guard error:', e);
    }
  }

  if (authRequired && !loggedIn) {
    //console.log('auth is required and not logged in. Redirecting to /login now') ;
    if(to) {
      //console.log(`sending to login with redirect of ${to.path}`);
      return next({
        path: '/login',
        query: { redirectUrl: to.path }
      })
    }
    else {
      //console.log(`going to login without redirect`);
      return next('/login');
    }
  } else if (to.meta.requiresSuperAdmin) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      // Bounce to a CONCRETE page, never '/app': '/app' redirects to localStorage.redirectPath,
      // which for a Super Admin can be '/app/schedule' (the dev landing page) — '/app' here
      // would loop if user.Role and redirectPath ever disagreed. /app/todo needs only auth.
      if (!user || user.Role !== 'Super Admin') {
        return next('/app/todo');
      }
    } catch (e) {
      return next('/app/todo');
    }
    next();
  } else if (to.meta.requiresTxPresenter) {
    // Tx Presenter gate (replaced the bare Super Admin gate). Allow when:
    //   - User is Super Admin (safety net so we never lock ourselves out)
    //   - OR site has TX_PRESENTER_ENABLED='TRUE' in teamio.settings
    // On cold boot via a deep link, the customer store may not be hydrated
    // yet — in that case the settings array is empty and we redirect to
    // /app. The user lands on the dashboard, settings load, and they can
    // navigate back via the (now visible) sidebar entry. Acceptable trade-
    // off vs. async-awaiting the store hydration in the router guard.
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) return next('/login');
      if (user.Role === 'Super Admin') return next();
      const settings = (store && store.state && store.state.customer && store.state.customer.settings) || [];
      const txFlag = settings.find((s) => s && s.Property === 'TX_PRESENTER_ENABLED');
      if (txFlag && txFlag.PropertyValue === 'TRUE') return next();
      return next('/app');
    } catch (e) {
      return next('/app');
    }
  } else if (to.meta.requiresInsuranceVerification) {
    // Insurance Verification gate (mirrors requiresTxPresenter). Allow when:
    //   - User is Super Admin (safety net so we never lock ourselves out)
    //   - OR site has INSURANCE_VERIFICATION_ENABLED='TRUE' in teamio.settings
    // On a cold-boot deep link the customer store may not be hydrated yet
    // (empty settings) — we redirect to /app; the user lands on the dashboard,
    // settings load, and the now-visible sidebar entry gets them back.
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) return next('/login');
      if (user.Role === 'Super Admin') return next();
      const settings = (store && store.state && store.state.customer && store.state.customer.settings) || [];
      const ivFlag = settings.find((s) => s && s.Property === 'INSURANCE_VERIFICATION_ENABLED');
      if (ivFlag && ivFlag.PropertyValue === 'TRUE') return next();
      return next('/app');
    } catch (e) {
      return next('/app');
    }
  } else if (to.meta.requiresAdminOrAbove) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user || (user.Role !== 'Super Admin' && user.Role !== 'Admin')) {
        return next('/app');
      }
    } catch (e) {
      return next('/app');
    }
    next();
  } else {
    /*
    if(to.meta.requiresFormVerification && !formVerified) {
      //console.log(`Requires form verification`);
      next(`/verify-form/${to.params.formID}`);
    }
    */
    if(from.name === 'VerifyForm' && to.name === 'ViewFormWithUrlID') {
      /*
        This means we have already verified the form and now redirecting. So let's remove that cookie
        so that if the user comes on this page again, they get prompted again
      */
      //console.log(`coming from verifyform and going to viewformwithurlid`);
      localStorage.removeItem('formverified');
      //console.log(`formverified removed`);
      next();
    }
    else {
      //console.log('no rules match on routes');
      next()
    }
  }
})

// Stale-bundle safety net: a chunk that 404s (because a deploy replaced the files this tab's
// index.html named) routes into the SAME "new version available" path the version poll uses —
// Layout's refresh toast on an active tab, its quiet reload on a hidden one. Never a silently
// dead navigation. Registers router.onError plus a capture-phase window 'error' listener for
// <script>/<link> chunk failures that never reach the router. Implementation and dedupe live in
// services/versionCheck.js; this is the only wiring point.
//
// DORMANT-BUT-ARMED: every page above is imported STATICALLY, so there is no async route chunk to
// fail today. This becomes load-bearing with the first lazy route (lazy-loading stage A2).
installStaleBundleHandlers(router);

// Demo site (Try Teamio): the public /demo and /try pages, added outside the table above (src/pages/Demo/demoRoutes.js).
addDemoRoutes(router);

export default router;